import React from "react";
import { NavLink } from "react-router-dom";
import { useNavigationContext } from "../features/navigation";
import { Home, Store, FileText, Menu } from "lucide-react";
import { AppBar, Box, Badge, IconButton, Toolbar } from "@mui/material";

const navItems = [
  { to: "/", icon: Home, label: "Home" },
  { to: "/my-dealer", icon: Store, label: "My Dealer", isNew: true },
  { to: "/my-diary", icon: FileText, label: "Diary" },
];

const BottomNavbar = () => {
  const { toggleSidebar } = useNavigationContext();

  return (
    <AppBar
      position="fixed"
      sx={{
        top: "auto",
        bottom: 0,
        bgcolor: "white",
        boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
        zIndex: 50,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          justifyContent: "center",
          minHeight: "56px !important",
          maxWidth: { md: "480px" },
          width: "100%",
          mx: "auto",
        }}
      >
        {navItems.map(({ to, icon: Icon, label, isNew }) => (
          <NavLink
            key={to}
            to={to}
            style={{ flex: 1, display: "flex", justifyContent: "center" }}
          >
            {({ isActive }) => (
              <IconButton
                disableRipple
                sx={{
                  color: isActive ? "#3901FF" : "#2B2B2B",
                  flexDirection: "column",
                  borderRadius: 0,
                  width: "100%",
                  "&:hover": { color: "#3901FF", bgcolor: "transparent" },
                }}
              >
                <Badge
                  badgeContent={isNew ?  label || "NEW" : null}
                  sx={{
                    "& .MuiBadge-badge": {
                      bgcolor: "#ef4444",
                      color: "white",
                      fontSize: "0.6rem",
                      fontWeight: 700,
                      minWidth: 0,
                      height: "auto",
                      padding: "2px 4px",
                      borderRadius: "999px",
                      lineHeight: 1,
                    },
                  }}
                >
                  <Icon size={24} />
                </Badge>
              </IconButton>
            )}
          </NavLink>
        ))}

        {/* Menu Button */}
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <IconButton
            onClick={toggleSidebar}
            aria-label="Open menu"
            sx={{
              color: "#2B2B2B",
              flexDirection: "column",
              borderRadius: 0,
              width: "100%",
              "&:hover": { color: "#3901FF", bgcolor: "transparent" },
            }}
          >
            <Menu size={24} />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default BottomNavbar;
